import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit"]

  connect() {
    this.digitTargets[0].focus()
  }

  handleInput(event) {
    const input = event.target
    const index = this.digitTargets.indexOf(input)

    // Only allow single digits
    input.value = input.value.replace(/\D/g, "").slice(-1)

    if (input.value && index < this.digitTargets.length - 1) {
      this.digitTargets[index + 1].focus()
    }

    if (input.value && index === this.digitTargets.length - 1) {
      this.element.requestSubmit()
    }
  }

  handleKeydown(event) {
    const input = event.target
    const index = this.digitTargets.indexOf(input)

    if (event.key === "Backspace" && !input.value && index > 0) {
      this.digitTargets[index - 1].focus()
    }
  }

  handlePaste(event) {
    event.preventDefault()
    const paste = (event.clipboardData || window.clipboardData).getData("text").replace(/\D/g, "").slice(0, 6)

    paste.split("").forEach((char, i) => {
      if (this.digitTargets[i]) {
        this.digitTargets[i].value = char
      }
    })

    if (paste.length === 6) {
      this.element.requestSubmit()
    } else if (this.digitTargets[paste.length]) {
      this.digitTargets[paste.length].focus()
    }
  }
}
